
import { AuthCallbackContent } from '@/components/auth/callback/AuthCallbackContent';
import { useAuthCallback } from '@/components/auth/callback/useAuthCallback';

const AuthCallback = () => {
  const { error, processing, handleManualRedirect } = useAuthCallback();

  return (
    <AuthCallbackContent 
      error={error} 
      processing={processing}
      handleManualRedirect={handleManualRedirect}
    />
  );
};

export default AuthCallback;
